<template>
    <flex-element
        v-plaintext
        class-default-inline="f-relative f-text-center whitespace-no-wrap"
        tag="button"
        :type="renderType"
        :style="buttonStyle"
        :element-type="elementType"
    >
        <span
            v-text-select="singleLineTextNew"
            :contenteditable="isContentEditable"
            :style="textStyle"
            @input="setChangedData(true)"
            @blur="onInput"
        />

        <loading-icon
            v-if="isLoading"
            class="fc-center-middle"
            color="#fff"
        />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { AButton } from '@/data/data-models';
import listenOnRootMixin from '@/mixins/listen-on-root';
import LoadingIcon from '@/components/shared/loading/loading-icon';

export default {
    name: 'a-button',
    components: { LoadingIcon },
    mixins: [baseAtom, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'Button',
        },

        singleLineText: {
            type: String,
            default: '',
        },

        type: {
            type: String,
            default: '',
        },

        typeDefault: {
            type: String,
            default: 'button',
        },

        templateId: {
            type: String,
            default: '{BDCC27B8-F433-43FB-954A-C6BF0FD3752F}',
        },
    },

    data() {
        return {
            cssDisplay: 'inline-block',
            isLoading: false,
            singleLineTextNew: '',
            typeNew: '',
        };
    },

    computed: {
        renderType() {
            return this.typeNew || this.typeDefault;
        },

        buttonStyle() {
            return {
                pointerEvents: this.isLoading ? 'none' : 'auto',
                '-webkit-appearance': 'none',
            };
        },

        textStyle() {
            return {
                visibility: this.isLoading ? 'hidden' : 'visible',
            };
        },

        updatedElement() {
            return new AButton({
                ...this.updatedBaseElement,
                singleLineText: this.singleLineTextNew,
                type: this.typeNew,
            });
        },
    },

    created() {
        this.listenOnRoot('flex::form::submit', () => this.isLoading = true);
        this.listenOnRoot('flex::form::response', () => this.isLoading = false);
    },

    methods: {
        setFieldValues() {
            this.singleLineTextNew = this.singleLineText
                || (this.$slots.default ? this.$slots.default[0].text.trim() : '[Text here]');
            this.typeNew = this.type || this.typeDefault;
        },

        onInput(e) {
            this.singleLineTextNew = e.target.innerText;
        },
    },
};
</script>
